angular.module('zc.projects')

.directive 'zcIncentiveTable', (Incentive, Devise, CampaignStats, lib)->
  restrict: 'E'
  templateUrl: '/templates/projects.incentives/incentive_table.html'
  scope:
    project: '='
    incentives: '='
    campaign: '='
    filters: '='
    onUpdate: '='
    showsDetail: '='
  link: (scope, element, attrs) ->
    scope.Devise = Devise
    scope.copy = (incentive) ->
      newIncentive = _.assignIn {}, incentive
      newIncentive.id = undefined
      newIncentive.name = lib.copyName(incentive.name)

      Incentive.create
        projectId: scope.project.id
      , newIncentive
      .then scope.onUpdate

    scope.remove = (incentive) ->
      Incentive.delete(scope.project.id, incentive.id).then scope.onUpdate

    updateData = ->
      return unless scope.campaign and scope.filters
      CampaignStats.aggregate
        dimension: 'daily'
        campaign_id: scope.campaign.id
        apikey: scope.campaign.apikey
        start_at: scope.filters.start_at
        end_at: scope.filters.end_at
      .then (campaign_stats) ->
        scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id]
    scope.$watch 'filters', updateData, true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.incentives/incentive_table.directive.coffee